<script setup lang="ts">
const props = defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})

const pages = computed(() => props?.slice?.Pages?.filter((page: Record<string, unknown>) => !!page) || [])
</script>

<template>
  <StrapiSlice
    class="ct-page-feed"
    :slice="slice"
    :index="index"
  >
    <UiCarousel
      v-if="slice?.FeedDisplay?.Display === 'Slider'"
      class="ct-page-feed__carousel"
      :class="{
        /* Non responsive & non modern settings */
        'ui-carousel--center': false,
        'ui-carousel--free-scroll': true,
        'ui-carousel--navigation': true,
        'ui-carousel--pagination': false,
        'ui-carousel--progress': false,
      }"
    >
      <template
        v-for="(page, i) in pages"
        #[`slide-${i}`]
        :key="page"
      >
        <CmsTile
          :page="page"
          :lazy="index > 0 || i > 2"
          class="ct-page-feed__blog"
        />
      </template>
    </UiCarousel>

    <div
      v-else-if="slice?.FeedDisplay?.Display === 'Grid' && pages?.length"
      class="ct-page-feed__grid"
    >
      <CmsTile
        v-for="(page, i) in pages"
        :key="page"
        :page="page"
        :lazy="index > 0 || i > 2"
        class="ct-page-feed__blog"
      />
    </div>
  </StrapiSlice>
</template>

<style>
@import url("~layers/app/components/Slices/PageFeed.css");
</style>
